var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "col-12"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm.hasPermission('locations.services.edit') ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('div', {
    staticClass: "d-none d-sm-block float-right"
  }, [_vm.hasEditableFields ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.saveProperties
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.save')))]) : _vm._e()])]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.service-settings.title')) + " ")]), _c('div', {
    staticClass: "table-responsive table-hover"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "auto"
    }
  }), _vm._l(_vm.dispatchTypes, function (dispatchType, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "align-text-top pt-3"
    }, [_c('strong', [_vm._v(_vm._s(dispatchType.display_name))])]), _c('td', {
      staticClass: "align-middle"
    }, [!dispatchType.is_active ? _c('p', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.off')))]) : dispatchType.readonly ? _c('p', [dispatchType.is_active_for_location !== '0' ? _c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.on')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.off')))])]) : _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: dispatchType.is_active_for_location,
        expression: "dispatchType.is_active_for_location"
      }],
      attrs: {
        "type": "radio",
        "value": "0",
        "name": dispatchType.identifier,
        "id": `${dispatchType.identifier}False`
      },
      domProps: {
        "checked": _vm._q(dispatchType.is_active_for_location, "0")
      },
      on: {
        "change": function ($event) {
          return _vm.$set(dispatchType, "is_active_for_location", "0");
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": `${dispatchType.identifier}False`
      }
    }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.off')))]), _c('br'), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: dispatchType.is_active_for_location,
        expression: "dispatchType.is_active_for_location"
      }],
      attrs: {
        "type": "radio",
        "value": "1",
        "name": dispatchType.identifier,
        "id": `${dispatchType.identifier}True`
      },
      domProps: {
        "checked": _vm._q(dispatchType.is_active_for_location, "1")
      },
      on: {
        "change": function ($event) {
          return _vm.$set(dispatchType, "is_active_for_location", "1");
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": `${dispatchType.identifier}True`
      }
    }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.on')))])]), _vm._l(dispatchType.carriers, function (carrier) {
      return dispatchType.is_active && dispatchType.is_active_for_location !== '0' ? _c('b-card', {
        key: carrier.id,
        staticClass: "mb-1 bg-light shadow-none",
        attrs: {
          "no-body": ""
        }
      }, [_c('b-card-body', {
        staticClass: "pb-1"
      }, [_c('b-card-title', [_vm._v(_vm._s(carrier.display_name))]), _vm._l(carrier.carrier_methods, function (carrierMethod) {
        return _c('div', {
          key: carrierMethod.id
        }, [_c('table', {
          staticClass: "table-sm",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('col', {
          staticStyle: {
            "width": "30%"
          }
        }), _c('col', {
          staticStyle: {
            "width": "auto"
          }
        }), _c('tr', [_c('td', [_c('i', [_vm._v(_vm._s(carrierMethod.display_name))])]), _c('td', [!carrierMethod.is_active ? _c('p', {
          staticClass: "pt-2"
        }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.off')))]) : carrierMethod.readonly || dispatchType.readonly ? _c('p', [carrierMethod.is_active_for_location !== '0' ? _c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.on')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.off')))])]) : _c('span', [_c('b-form-checkbox', {
          attrs: {
            "switch": "",
            "id": `${dispatchType.identifier}${carrierMethod.identifier}`,
            "name": `${dispatchType.identifier}${carrierMethod.identifier}`,
            "unchecked-value": '0',
            "value": '1'
          },
          model: {
            value: carrierMethod.is_active_for_location,
            callback: function ($$v) {
              _vm.$set(carrierMethod, "is_active_for_location", $$v);
            },
            expression: "carrierMethod.is_active_for_location"
          }
        })], 1)])])]), _c('table', {
          staticStyle: {
            "width": "100%"
          }
        }, [_c('col', {
          staticStyle: {
            "width": "5%"
          }
        }), _c('col', {
          staticStyle: {
            "width": "25%"
          }
        }), _c('col', {
          staticStyle: {
            "width": "auto"
          }
        }), _vm._l(carrierMethod.properties, function (property, propertyKey) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: carrierMethod.is_active && carrierMethod.is_active_for_location !== '0',
              expression: "carrierMethod.is_active && carrierMethod.is_active_for_location !== '0'"
            }],
            key: `${carrierMethod.id}.${propertyKey}`
          }, [_c('td'), _c('td', [_vm._v(_vm._s(property.display_name))]), _c('td', [carrierMethod.readonly || dispatchType.readonly || property.readonly ? _c('textarea', {
            staticClass: "form-control",
            attrs: {
              "disabled": "disabled"
            },
            domProps: {
              "value": carrierMethod.properties[propertyKey].value
            }
          }) : _c('textarea', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: carrierMethod.properties[propertyKey].value,
              expression: "carrierMethod.properties[propertyKey].value"
            }],
            staticClass: "form-control",
            domProps: {
              "value": carrierMethod.properties[propertyKey].value
            },
            on: {
              "input": function ($event) {
                if ($event.target.composing) return;
                _vm.$set(carrierMethod.properties[propertyKey], "value", $event.target.value);
              }
            }
          })])]);
        })], 2)]);
      })], 2)], 1) : _vm._e();
    })], 2)]);
  })], 2)])], 1)], 1)]), _vm.hasPermission('locations.services.edit') ? _c('div', {
    staticClass: "col-12 my-3"
  }, [_c('div', {
    staticClass: "d-none d-sm-block float-right"
  }, [_vm.hasEditableFields ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.saveProperties
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.save')))]) : _vm._e()])]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }